import React, { useEffect } from 'react'
import './RagGraph.css'
    function rnd(num){
        return Math.round(num * 100) / 100
        }
function RagGraphCommitted({isCommittedRaggraph,ragThreshold}) {
    const orgColors = wbConfig.orgColors;
    let currentRagColor = null;
    let ragColor = '';
    if (orgColors != null) {
        currentRagColor = orgColors.rag_color.colors;
    } 
    let darkGreen = ragThreshold[1]|| 90;
    let lightGreen =ragThreshold[2]||75;
    let amber = ragThreshold[3]|| 50;
    let commited = isCommittedRaggraph; 
    darkGreen = darkGreen / 100;
    lightGreen = lightGreen/100;
    amber = amber/100;
    let ragClass = [
        '',
        'rDg',
        'rLg',
        'rA',
        'rR'
    ];
    let ragTable = '<div>';
    let color = '';
    let start = '';
    let end = 153;
    let exp = '';
    let expProg = '';
    let nextExpProg = '';
    let expProg2 = '';
    let currentRagClass = '';
    for(let y=122; y>=0; y--)
    {
        ragTable += '<div class="Gtr">';
        for(let x=1; x<=end; x++){
            color = '';
            start = x;		
            exp = (x/end);
            expProg2 = 1 - exp;
            exp *= 119;
            expProg = rnd(y/exp);
            nextExpProg = rnd((y -1)/exp);
            if(!commited) {
                if (start <= (end*0.25)) {
                    if(expProg > darkGreen){
                        color = 1; 
                    } else {
                        color = 2;
                    }
                } else if (start <= (end*0.33)) 
                {
                    if(expProg > darkGreen){
                        color = 1; 
                    }else if(expProg > lightGreen){
                        color = 2; 
                    }else{
                        color = 3;
                    }
                } else if (start > (end * 0.33)){			
                    if(nextExpProg >= darkGreen){
                        color = 1;
                    } else if (nextExpProg >= lightGreen){
                        color = 2;
                    } else if (nextExpProg >= amber){
                        color = 3;
                    }else {
                        color = 4;				
                    }
                }
            } else {
                if (start <= (end* 0.25)) {
                        //=IF((C$102<=$CN$102*0.25),IF(($B1/C$103>1),"Dark Green","Amber")
                        if(expProg > darkGreen){
                            color = 1;
                        } else {
                            color = 1;
                        }
                    } 
                    else if (start <= (end * 0.33)) {
                        //IF((C$102<=$CN$102*0.33),IF(($B1/C$103>1),"Dark Green",IF(($B1/C$103>0.7),"Amber","Amber"))
                        if(expProg > darkGreen){
                            color = 1;
                        }else if(expProg > lightGreen){
                            color = 3;
                        }else{
                            color = 3;
                        }
                    } else if ( start> (end * 0.33)){			
                        //	IF((C$102>$CN$102*0.33),IF(($B1/C$103)>=1,"Dark Green",	IF(($B1/C$103)*(1-(C$102/$CN$102))>=0.1,"Amber",	"Red")))
                        if(expProg >= 1){
                            color = 1;
                        } else if ((expProg * expProg2) >= 0.1){
                            color = 3;
                        }else {
                            color = 4;
                        }
                    }
            }
            if (currentRagColor != null) {
                ragColor = currentRagColor[color];
                ragTable  += '<a style ="background-color:'+ragColor+'" class="Gtd"></a>';
            } else {
                currentRagClass = ragClass[color];
                ragTable  += '<a class="Gtd '+currentRagClass+'"></a>';
            }
            
        }
        ragTable +='</div>';
    }
    ragTable += '</div>';
useEffect(()=>{
    document.getElementById('RagGraphId').innerHTML = ragTable;
 
})
  return (    
    <div id="RagGraphId" className="ragGraphId" data-testid="ragGraphId" style={{opacity:0.75}}></div>
  )
}

export default RagGraphCommitted